module.exports = __webpack_public_path__ + "img/mark2_n.ee2a89e5.png";